<div class="preview-display-row">
  <div class="preview-image-container"  *ngIf="isImage && !imageError" (click)="fileLink.click()">
    <img [src]="fileURL" [alt]="fileName" (error)="onImageError()"/>
  </div>
  <div class="preview-image-text">
    <a [href]="fileURL" #fileLink>{{fileName}}</a>
  </div>
</div>